import LandmarkTrigger from './landmark-trigger';

export default function(element, data, sendLandmark) {
    const handler = () => {
        data.landmark = 'userinterface';

        data.navi = data.naviswipe;
        delete data.naviswipe;

        if (LandmarkTrigger.shouldTriggerLandmark(element)) {
            sendLandmark(data);
        }
    }

    element.addEventListener('scroll', handler);

    if (element.getAttribute('jsh-landmark-trigger-once')) {
        element.removeEventListener('scroll', handler);
    }
}